import React from 'react';
import AssortmentReport from './AssortmentReport';
import { useAssortmentReportFetch } from './hooks';
import { Alert, Icon, Spin } from 'antd';
import Widget from 'src/components/common/Widget';
import TableauView from '../Interactive/DefinedReports/DefinedReport/TableauView';
import styles from './Assortment.module.less';

const antIcon = <Icon type="loading" spin />;

type AssortmentProps = {};
const Assortment: React.FC<AssortmentProps> = () => {
  const [{ data, loading, error }, errorMsg] = useAssortmentReportFetch();
  const enableCloudTableau = data?.enable_cloud_tableau;
  const reportUrl = data?.reportURL;
  return (
    <Widget>
      {(error || errorMsg) && <Alert message="Error" description={errorMsg || error} type="error" showIcon />}
      {loading && !error && !errorMsg ? (
        <div className={styles.insights_loader_container}>
          <Spin indicator={antIcon} size="large" spinning={loading} />
        </div>
      ) : null}
      {data && (
        <div>
          {reportUrl && enableCloudTableau === true ? (
            <TableauView reportUrl={reportUrl} />
          ) : (
            <AssortmentReport url={reportUrl} errorMsg={errorMsg || error}/>
          )}
        </div>
      )}
    </Widget>
  );
};

export default Assortment;
